import {Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/localization';
import {CompanyKeyEnum} from '../../../../../../service/company-v2/company-const';

import {DESCRIPTION_LIMITS} from './descriptions-widget-const';
import {LongDescriptionFormItem} from './long-description-form-item/long-description-form-item';
import * as styles from './descriptions-widget.scss';

export function DescriptionsWidget(): JSX.Element {
    return (
        <div className={styles.descriptions_widget__wrapper}>
            <div className={styles.descriptions_widget__inputs}>
                <LongDescriptionFormItem
                    maxLength={DESCRIPTION_LIMITS.long}
                    name={[CompanyKeyEnum.Descriptions, 'long']}
                />
            </div>

            <Typography.Text className={styles.descriptions_widget__description} type="secondary">
                <Locale stringKey="COMPANY_FORM__DESCRIPTIONS__DESCRIPTION" />
            </Typography.Text>
        </div>
    );
}
